// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__6ySk2","title":"Section_title__YXAQt"};